export { }
declare global {
    export interface String {
        removeWhiteSpace(): string
        isNullOrEmpty(): boolean
        formatToZipCode(): string
        isValidCPF(): boolean
        isValidCNPJ(): boolean
        formatToMainDocument(): string
        formatToPhoneNumber(): string
        isValidPhoneNumber(): boolean
        formatCreditCard(): string
        formatCreditCardMask(): string
        tryParseJson<T = any>(fallback?: T): T | null
    }
}

String.prototype.removeWhiteSpace = function (): string {
    return this.replaceAll(" ", "")
}

String.prototype.isNullOrEmpty = function (): boolean {
    return this === undefined || this === null || this === '' || this.length === 0
}

String.prototype.formatToZipCode = function (): string {
    return this.replace(/^(\d{5})(\d)/, '$1-$2')
}

String.prototype.isValidCPF = function (): boolean {
    let cpf = this.removeWhiteSpace().replace(/[^\d]/g, '')

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false

    let soma = 0
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let remainder = soma % 11
    let digit1 = remainder < 2 ? 0 : 11 - remainder

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i)
    }
    remainder = soma % 11
    let digito2 = remainder < 2 ? 0 : 11 - remainder

    return digit1 === parseInt(cpf.charAt(9)) && digito2 === parseInt(cpf.charAt(10))
}

String.prototype.isValidCNPJ = function (): boolean {
    let cnpj = this.removeWhiteSpace().replace(/[^\d]/g, '')

    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false

    let size = cnpj.length - 2
    let number = cnpj.substring(0, size)
    let digits = cnpj.substring(size)
    let soma = 0
    let pos = size - 7

    for (let i = size; i >= 1; i--) {
        soma += parseInt(number.charAt(size - i)) * pos--
        if (pos < 2) pos = 9
    }

    let result = soma % 11 < 2 ? 0 : 11 - soma % 11
    if (result != parseInt(digits.charAt(0))) return false

    size = size + 1
    number = cnpj.substring(0, size)
    soma = 0
    pos = size - 7

    for (let i = size; i >= 1; i--) {
        soma += parseInt(number.charAt(size - i)) * pos--
        if (pos < 2) pos = 9
    }

    result = soma % 11 < 2 ? 0 : 11 - soma % 11
    return result === parseInt(digits.charAt(1))
}

String.prototype.formatToMainDocument = function (): string {
    const cleaned = this.replace(/\D/g, ""); // Remove todos os caracteres não numéricos

    // Detecta e formata CPF (11 dígitos)
    if (/^\d{11}$/.test(cleaned)) {
        return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    }

    // Detecta e formata CNPJ (14 dígitos)
    if (/^\d{14}$/.test(cleaned)) {
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }

    return cleaned;
};

String.prototype.formatToPhoneNumber = function (): string {
    const cleaned = this.replace(/[^0-9()\-]/g, "");
    const digitsOnly = cleaned.replace(/\D/g, "");

    // Valida e formata (99) 99999-9999
    const mobileMatch = digitsOnly.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (mobileMatch) return `(${mobileMatch[1]}) ${mobileMatch[2]}-${mobileMatch[3]}`;

    // Valida e formata (99) 9999-9999
    const landlineMatch = digitsOnly.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (landlineMatch) return `(${landlineMatch[1]}) ${landlineMatch[2]}-${landlineMatch[3]}`;

    return cleaned;
};

String.prototype.isValidPhoneNumber = function (): boolean {
    const mobileRegex = /^\(\d{2}\) \d{5}-\d{4}$/
    const landlineRegex = /^\(\d{2}\) \d{4}-\d{4}$/

    return mobileRegex.test(this.toString()) || landlineRegex.test(this.toString())
}

String.prototype.formatCreditCard = function (): string {
    const cleaned = this.replace(/\D/g, '')
    return cleaned.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
}

String.prototype.formatCreditCardMask = function (): string {
    const cleaned = this.replace(/\D/g, '');
    const first6 = cleaned.slice(0, 6);
    const last4 = cleaned.slice(-4);
    const maskedSection = cleaned.slice(6, -4).replace(/\d/g, '•');
    return `${first6}${maskedSection}${last4}`;
}

String.prototype.tryParseJson = function <T = any>(fallback: T | null = null): T | null {
    if (typeof this !== 'string') return fallback

    try {
        return JSON.parse(this.toString())
    } catch (e) {
        return fallback
    }
}